import routerOptions0 from "/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7__@babel+plugin-s_e2eb9020c3576dd4fdd816534d9f0319/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}